"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.profile = exports.getNowTimeStamp = exports.ProfileAction = void 0;
const ConsoleReporter_1 = require("./ConsoleReporter");
const DefaultProfilerActivator_1 = require("./DefaultProfilerActivator");
const scanListSymbol = Symbol('profilerMetaScan');
var ProfileAction;
(function (ProfileAction) {
    ProfileAction[ProfileAction["default"] = 0] = "default";
    ProfileAction[ProfileAction["sdkOptionsScan"] = 1] = "sdkOptionsScan";
    ProfileAction[ProfileAction["entry"] = 2] = "entry";
    ProfileAction[ProfileAction["ignore"] = 3] = "ignore";
})(ProfileAction = exports.ProfileAction || (exports.ProfileAction = {}));
const scalableActions = [ProfileAction.entry, ProfileAction.sdkOptionsScan];
const shouldScan = (action) => scalableActions.includes(action);
const ProfilerActivationPropertyName = 'isProfilerActive';
const isPromise = (obj) => {
    return !!obj && (typeof obj === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
};
exports.getNowTimeStamp = () => Date.now();
function scanSdkOptions(action, args, activator, obj, recorder) {
    if (action === ProfileAction.sdkOptionsScan) {
        const profilerOptions = [...args].find((a) => typeof a === 'object' && a && typeof a[ProfilerActivationPropertyName] === 'boolean');
        if (profilerOptions && profilerOptions[ProfilerActivationPropertyName]) {
            if (activator.isActive() !== profilerOptions[ProfilerActivationPropertyName]) {
                activator.setActive(profilerOptions.isProfilerActive);
                //TODO : think about deactivate case
                if (activator.isActive()) {
                    wrapClass(obj, recorder, activator, action);
                }
            }
        }
    }
}
function wrapFunction(obj, key, className, recorder, activator, action = ProfileAction.default) {
    const descriptor = Reflect.getOwnPropertyDescriptor(obj, key);
    if (!descriptor || descriptor.get || descriptor.set) {
        return;
    }
    if (key === 'constructor') {
        return;
    }
    const originalFunction = descriptor.value;
    if (!originalFunction || typeof originalFunction !== 'function') {
        return;
    }
    // set a key for the object in memory
    if (!className) {
        className = obj.constructor ? `${obj.constructor.name}` : '';
    }
    const name = key.toString();
    // set a tag so we don't wrap a function twice
    const savedName = `__scan__${name}__`;
    if (Reflect.has(obj, savedName)) {
        return;
    }
    const wrappedFunction = function (...args) {
        if (activator.isActive() || shouldScan(action)) {
            scanSdkOptions(action, args, activator, obj, recorder);
            const start = exports.getNowTimeStamp();
            const result = originalFunction.apply(this, args);
            if (isPromise(result)) {
                return result
                    .then(() => {
                    recorder.record(name, className, start, exports.getNowTimeStamp());
                    return result;
                })
                    .catch(() => {
                    recorder.record(name, className, start, exports.getNowTimeStamp());
                    return result;
                });
            }
            recorder.record(name, className, start, exports.getNowTimeStamp());
            return result;
        }
        return originalFunction.apply(this, args);
    };
    Reflect.set(obj, savedName, originalFunction);
    Reflect.set(obj, key, wrappedFunction, obj);
}
function wrapChain(chain, className, profilerRecorder, profileActivator, action) {
    if (action === ProfileAction.ignore) {
        return;
    }
    const scanList = Reflect.get(chain, scanListSymbol) || [];
    const scanMap = scanList.reduce((result, value) => {
        result[value.key] = value;
        return result;
    }, {});
    Reflect.ownKeys(chain).forEach((k) => {
        const meta = scanMap[k.toString()];
        const action = meta ? meta.action : null;
        if (action !== ProfileAction.ignore && DefaultProfilerActivator_1.DefaultProfilerActivator.isActive()) {
            wrapFunction(chain, k, className, profilerRecorder, profileActivator, action);
        }
        if (shouldScan(action)) {
            wrapFunction(chain, k, className, profilerRecorder, profileActivator, action);
        }
    });
}
function wrapClass(target, profilerRecorder, profileActivator, action) {
    const ctor = target;
    if (!ctor.prototype) {
        return;
    }
    const className = ctor.name;
    wrapChain(ctor.prototype, '', profilerRecorder, profileActivator, action);
    wrapChain(ctor, className, profilerRecorder, profileActivator, action);
}
exports.profile = (action = ProfileAction.default, profilerRecorder = ConsoleReporter_1.ConsoleReporter, profileActivator = DefaultProfilerActivator_1.DefaultProfilerActivator) => (
// eslint-disable-next-line @typescript-eslint/ban-types
target, key, 
// eslint-disable-next-line no-unused-vars,@typescript-eslint/ban-types
_descriptor) => {
    if (key) {
        Reflect.set(target, scanListSymbol, (Reflect.get(target, scanListSymbol) || []).concat({ key, action }));
        return;
    }
    wrapClass(target, profilerRecorder, profileActivator, action);
};
//# sourceMappingURL=ProfilerDecorator.js.map